export function formatNumber(
  numStr: string | number | null | undefined,
  padLength = 0,
): string {
  // Handle null/undefined inputs
  if (numStr === null || numStr === undefined || numStr === "") {
    return "Price on request";
  }

  // Convert to number
  const num = typeof numStr === "string" ? Number(numStr) : numStr;

  // Handle invalid numbers (NaN, Infinity, etc.)
  if (!Number.isFinite(num)) {
    return "Price on request";
  }

  // Format valid numbers
  const formattedNum = num.toFixed(0);
  return formattedNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
